import slugit from 'slugify';

export const slug = (from: string): string => {
    return slugit(from).toLowerCase();
}
